import { render, staticRenderFns } from "./editSN.vue?vue&type=template&id=2fab55ba&scoped=true"
import script from "./editSN.vue?vue&type=script&lang=js"
export * from "./editSN.vue?vue&type=script&lang=js"
import style0 from "./editSN.vue?vue&type=style&index=0&id=2fab55ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab55ba",
  null
  
)

export default component.exports